




































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwSpinningProgress } from '../sw-progress';
import { utilService } from '../util-service';
import { domService } from '../dom-service';

const cssPrefix = 'sw-blocking-progress';

@Component({
  components: {
    SwSpinningProgress,
  },
})
export default class SwBlockingProgress extends SwExtendedVue {
  @Prop()
  message: string;

  @Prop({ type: Number, default: 64 })
  size: number;

  @Prop({ type: Boolean, default: false })
  visible: boolean;

  @Prop({ type: Boolean, default: false })
  forViewport: boolean;

  cssPrefix = cssPrefix;

  color: string = utilService.colorConst.selected;

  bodyStyleTicket: string = '';

  @Watch('visible', { immediate: true })
  private onVisibleChange() {
    if (this.visible) {
      if (this.forViewport) {
        this.bodyStyleTicket = domService.stylesManager.apply(document.body, { overflowX: 'hidden', overflowY: 'hidden' });
      }
    } else {
      if (!!this.bodyStyleTicket) {
        domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
        this.bodyStyleTicket = '';
      }
    }
  }

  private beforeDestroy() {
    if (!!this.bodyStyleTicket) {
      domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
      this.bodyStyleTicket = '';
    }
  }
}
